<ct-lib-modal
  [medium]="true"
  [closeable]="false"
  [hideHeader]="true"
  [hideFooter]="true"
  [dynamic]="true"
  #onboardingModal
>
  <app-animated-height-container #animatedHeightContainer>
    <div class="onboarding">
      <div
        class="progress-bar"
        [style.height.px]="5"
        [style.width]="getProgressBarWidth() + '%'"
      ></div>
      <div class="steps p-4" #onboardingContent>
        @switch (step()) {
          @case (1) {
            <div class="step" @modalStepSlow>
              <div class="step-header">
                <h2>
                  {{ 'company-tool.onboarding.modal.step-1.title' | transloco }}
                </h2>
              </div>
              <div class="step-content py-3">
                <form [formGroup]="profileForm">
                  <div class="row">
                    <div
                      class="col-12 col-md-6 form-group form-floating"
                      [class.invalid]="
                        profileForm.get('firstName')?.invalid &&
                        profileFormSubmitAttempt()
                      "
                    >
                      <input
                        type="text"
                        class="form-control"
                        [formControl]="profileForm.get('firstName')"
                        [placeholder]="
                          'company-tool.onboarding.modal.forms.profile.first-name.label'
                            | transloco
                        "
                        id="firstName"
                        autocomplete="given-name"
                      />
                      <label for="firstName">{{
                        'company-tool.onboarding.modal.forms.profile.first-name.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 form-group form-floating"
                      [class.invalid]="
                        profileForm.get('lastName')?.invalid &&
                        profileFormSubmitAttempt()
                      "
                    >
                      <input
                        type="text"
                        class="form-control"
                        [formControl]="profileForm.get('lastName')"
                        [placeholder]="
                          'company-tool.onboarding.modal.forms.profile.last-name.label'
                            | transloco
                        "
                        id="lastName"
                        autocomplete="family-name"
                      />
                      <label for="lastName">{{
                        'company-tool.onboarding.modal.forms.profile.last-name.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 form-group form-floating"
                      [class.invalid]="
                        profileForm.get('companyName')?.invalid &&
                        profileFormSubmitAttempt()
                      "
                    >
                      <input
                        type="text"
                        class="form-control"
                        [formControl]="profileForm.get('companyName')"
                        [placeholder]="
                          'company-tool.onboarding.modal.forms.profile.company-name.label'
                            | transloco
                        "
                        id="companyName"
                        autocomplete="organization"
                        maxlength="200"
                      />
                      <label for="companyName">{{
                        'company-tool.onboarding.modal.forms.profile.company-name.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 form-group form-floating mb-2"
                      [class.invalid]="
                        profileForm.get('headquartersHereId')?.invalid &&
                        profileFormSubmitAttempt()
                      "
                    >
                      <app-location-input
                        [label]="headquartersLabel()"
                        [control]="profileForm.get('headquartersHereId')"
                        [submitAttempt]="profileFormSubmitAttempt()"
                        [placeholder]="
                          'company-tool.onboarding.modal.forms.profile.facility.label'
                            | transloco
                        "
                      >
                      </app-location-input>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
          @case (2) {
            <div class="step" @modalStepSlow>
              <div class="step-header">
                <h2>
                  {{ 'company-tool.onboarding.modal.step-2.title' | transloco }}
                </h2>
                <p>
                  {{
                    'company-tool.onboarding.modal.step-2.subtitle' | transloco
                  }}
                </p>
              </div>
              <div class="step-content py-3">
                <form [formGroup]="companyForm">
                  <div class="row">
                    <div
                      class="col-12 form-group form-floating"
                      [class.invalid]="
                        companyForm.get('role')?.invalid &&
                        companyFormSubmitAttempt()
                      "
                    >
                      <ng-select
                        appendTo="body"
                        class="form-control select-line-break"
                        [formControl]="companyForm.get('role')"
                        clearable="false"
                        searchable="false"
                        id="role"
                        [placeholder]="
                          'ct-library.constants.ng-select.placeholders.placeholder'
                            | transloco
                        "
                      >
                        @for (role of [1, 2, 3, 4, 5]; track role) {
                          <ng-option [value]="role">{{
                            'company-tool.onboarding.modal.forms.company.role.options.' +
                              role | transloco
                          }}</ng-option>
                        }
                      </ng-select>
                      <label for="role">{{
                        'company-tool.onboarding.modal.forms.company.role.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 form-group form-floating"
                      [class.invalid]="
                        companyForm.get('numOfEmployees')?.invalid &&
                        companyFormSubmitAttempt()
                      "
                    >
                      <ng-select
                        appendTo="body"
                        class="form-control select-line-break"
                        [formControl]="companyForm.get('numOfEmployees')"
                        clearable="false"
                        searchable="false"
                        id="numOfEmployees"
                        [placeholder]="
                          'ct-library.constants.ng-select.placeholders.placeholder'
                            | transloco
                        "
                      >
                        @for (
                          employeeIntervalConstant of constantsService.getLabelValueArray(
                            constantsService.employeeIntervalConstants
                          );
                          track employeeIntervalConstant.value
                        ) {
                          <ng-option [value]="employeeIntervalConstant.value">
                            {{ employeeIntervalConstant.label | transloco }}
                          </ng-option>
                        }
                      </ng-select>
                      <label for="numOfEmployees">{{
                        'company-tool.onboarding.modal.forms.company.num-of-employees.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 form-group form-floating mb-2"
                      [class.invalid]="
                        companyForm.get('industry')?.invalid &&
                        companyFormSubmitAttempt()
                      "
                    >
                      <ng-select
                        appendTo="body"
                        class="form-control select-line-break"
                        [formControl]="companyForm.get('industry')"
                        clearable="false"
                        id="industry"
                        [placeholder]="
                          'company-tool.onboarding.modal.forms.company.industry.placeholder'
                            | transloco
                        "
                      >
                        @for (
                          industryConstant of constantsService.getLabelValueArray(
                            constantsService.industryConstants
                          );
                          track industryConstant
                        ) {
                          <ng-option [value]="industryConstant.value">
                            {{ industryConstant.label | transloco }}</ng-option
                          >
                        }
                      </ng-select>
                      <label for="industry">{{
                        'company-tool.onboarding.modal.forms.company.industry.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
          @case (3) {
            <div class="step" @modalStepSlow>
              <div class="step-header">
                <h2>
                  {{ 'company-tool.onboarding.modal.step-3.title' | transloco }}
                </h2>
                <p>
                  {{
                    'company-tool.onboarding.modal.step-3.subtitle' | transloco
                  }}
                </p>
              </div>
              <div class="step-content py-3">
                <form [formGroup]="teamForm">
                  <div class="row">
                    <div
                      class="col-12 form-group form-floating"
                      [class.invalid]="
                        teamForm.get('sizeOfRecruitingTeam')?.invalid &&
                        teamFormSubmitAttempt()
                      "
                    >
                      <ng-select
                        appendTo="body"
                        class="form-control select-line-break"
                        [formControl]="teamForm.get('sizeOfRecruitingTeam')"
                        clearable="false"
                        searchable="false"
                        id="sizeOfRecruitingTeam"
                        [placeholder]="
                          'ct-library.constants.ng-select.placeholders.placeholder'
                            | transloco
                        "
                      >
                        @for (size of [5, 4, 3, 2, 1]; track size) {
                          <ng-option [value]="size">{{
                            'company-tool.onboarding.modal.forms.team.team-size.options.' +
                              size | transloco
                          }}</ng-option>
                        }
                      </ng-select>
                      <label for="sizeOfRecruitingTeam">{{
                        'company-tool.onboarding.modal.forms.team.team-size.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-12 form-group form-floating mb-2"
                      [class.invalid]="
                        teamForm.get('numOfYearlyApplications')?.invalid &&
                        teamFormSubmitAttempt()
                      "
                    >
                      <ng-select
                        appendTo="body"
                        class="form-control select-line-break"
                        [formControl]="teamForm.get('numOfYearlyApplications')"
                        clearable="false"
                        searchable="false"
                        id="numOfYearlyApplications"
                        [placeholder]="
                          'ct-library.constants.ng-select.placeholders.placeholder'
                            | transloco
                        "
                      >
                        @for (num of [5, 4, 3, 2, 1]; track num) {
                          <ng-option [value]="num">{{
                            'company-tool.onboarding.modal.forms.team.num-of-applications.options.' +
                              num | transloco
                          }}</ng-option>
                        }
                      </ng-select>
                      <label for="numOfYearlyApplications">{{
                        'company-tool.onboarding.modal.forms.team.num-of-applications.label'
                          | transloco
                      }}</label>
                      <div class="validation">
                        <p>
                          {{ 'ct-library.validation.required' | transloco }}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
        }
        <div
          class="step-actions"
          [class.multiple]="step() > 1 && step() <= numOfSteps()"
        >
          @if (step() > 1 && step() <= numOfSteps()) {
            <app-button variant="white-grey" (click)="prev()">
              {{
                'company-tool.onboarding.modal.step-actions.prev' | transloco
              }}
            </app-button>
          }
          <div class="d-flex gap-2">
            @if (step() > 1) {
              <app-button variant="white-grey" (click)="skip()">
                {{
                  'company-tool.onboarding.modal.step-actions.skip' | transloco
                }}
              </app-button>
            }
            @if (step() === numOfSteps()) {
              <app-button
                class="align-self-end"
                [disabled]="sendingTeamForm()"
                [loading]="sendingTeamForm()"
                (click)="finish()"
              >
                {{
                  'company-tool.onboarding.modal.step-actions.next' | transloco
                }}
              </app-button>
            }
            @if (step() < numOfSteps()) {
              <app-button
                class="align-self-end"
                [disabled]="
                  sendingProfileForm() ||
                  sendingCompanyForm() ||
                  sendingTeamForm()
                "
                [loading]="
                  sendingProfileForm() ||
                  sendingCompanyForm() ||
                  sendingTeamForm()
                "
                (click)="next()"
              >
                {{
                  'company-tool.onboarding.modal.step-actions.next' | transloco
                }}
              </app-button>
            }
          </div>
        </div>
      </div>
    </div>
  </app-animated-height-container>
</ct-lib-modal>

<app-combined-subscription-booking-modal
  #combinedSubscriptionBookingModal
  (closed)="onSubscriptionBookingClosed()"
></app-combined-subscription-booking-modal>
